import { RUNS_ON_ATLASSIAN_PROGRAM } from '@atlassian/mpac-types';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
/**
 * Adapter which takes in REST + GraphQL Data & aggregates them
 * to provide a single source of data consumption for privacy & security tab
 *
 * REST Endpoint is temporary & we expect everything to be moved within
 * the GraphQL response in future, this should help make the transition simpler.
 *
 * Check './README.md' to know more.
 */
const appTrustDataAdapter = (appListingGql, trustDataApi) => {
  var _appListingGql$progra, _appListingGql$market, _appListingGql$partne;
  return {
    programs: appListingGql.programs,
    cloudFortified: (_appListingGql$progra = appListingGql.programs) === null || _appListingGql$progra === void 0 ? void 0 : _appListingGql$progra.cloudFortified,
    isRunsOnAtlassian: ((_appListingGql$market = appListingGql.marketingTags) === null || _appListingGql$market === void 0 ? void 0 : _appListingGql$market.some(tag => tag.name === RUNS_ON_ATLASSIAN_PROGRAM)) || false,
    partner: appListingGql.partner,
    privacyPolicyUrl: appListingGql.privacyPolicyUrl,
    appScopes: appListingGql.appScopes,
    dataAccessAndStorage: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.dataAccessAndStorage,
    thirdPartyInformation: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.thirdPartyInformation,
    dataResidency: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.dataResidency,
    dataRetention: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.dataRetention,
    logDetails: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.logDetails,
    privacy: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.privacy,
    security: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.security,
    byAtlassian: ((_appListingGql$partne = appListingGql.partner) === null || _appListingGql$partne === void 0 ? void 0 : _appListingGql$partne.partnerType) === MarketplacePartnerType.AtlassianInternal,
    properties: trustDataApi === null || trustDataApi === void 0 ? void 0 : trustDataApi.properties,
    deploymentType: appListingGql.deploymentType
  };
};
export default appTrustDataAdapter;